<template>
  <div class="join-page">
    <section class="join-hero">
      <div class="hero-copy">
        <p class="eyebrow">FISHROS · JOIN US</p>
        <h1>和我们一起，<br><em>让机器人走进更多真实世界。</em></h1>
        <p class="hero-desc">我们正在寻找相信长期主义的伙伴，把复杂的机器人技术做成每个人都能用、愿意用的产品。</p>
        <a class="primary-button" href="mailto:fishros@163.com?subject=加入鱼香ROS｜应聘岗位">发送简历 <span>↗</span></a>
      </div>
      <div class="hero-mark" aria-hidden="true"><span>+</span><span>×</span><span>○</span></div>
    </section>

    <section class="content-section">
      <div class="section-heading">
        <p class="eyebrow">OPEN POSITIONS</p>
        <h2>正在寻找的伙伴</h2>
        <p>没有看到完全匹配的岗位？如果你热爱机器人，也欢迎把想法和简历发给我们。</p>
      </div>
      <article class="job-detail">
        <div class="job-detail-top">
          <div class="job-heading">
            <h3>ROS 机器人工程师</h3>
            <p class="job-meta"><span>Base 合肥</span><span>本科及以上</span></p>
          </div>
          <div class="job-contact">
            <a class="contact-email" href="mailto:fishros@163.com">fishros@163.com</a>
            <a class="job-link" href="mailto:fishros@163.com?subject=应聘：ROS机器人工程师"><i class="el-icon-message" aria-hidden="true"></i> 投递简历</a>
          </div>
        </div>
        <dl class="job-keywords">
          <div class="keyword-row"><dt>岗位职责</dt><dd><ul class="experience-list"><li v-for="item in rosResponsibilities" :key="item">{{ item }}</li></ul></dd></div>
          <div class="keyword-row"><dt>任职要求</dt><dd><ul class="experience-list"><li v-for="item in rosRequirements" :key="item">{{ item }}</li></ul></dd></div>
        </dl>
      </article>
      <article class="job-detail secondary-job">
        <div class="job-detail-top">
          <div class="job-heading">
            <h3>机器人结构工程师</h3>
            <p class="job-meta"><span>Base 合肥</span><span>本科及以上</span></p>
          </div>
          <div class="job-contact">
            <a class="contact-email" href="mailto:fishros@163.com">fishros@163.com</a>
            <a class="job-link" href="mailto:fishros@163.com?subject=应聘：机器人结构工程师"><i class="el-icon-message" aria-hidden="true"></i> 投递简历</a>
          </div>
        </div>
        <dl class="job-keywords">
          <div class="keyword-row"><dt>岗位职责</dt><dd><ul class="experience-list"><li v-for="item in structureResponsibilities" :key="item">{{ item }}</li></ul></dd></div>
          <div class="keyword-row"><dt>任职要求</dt><dd><ul class="experience-list"><li v-for="item in structureRequirements" :key="item">{{ item }}</li></ul></dd></div>
        </dl>
      </article>
    </section>

    <section class="apply-section"><p class="eyebrow">SAY HELLO</p><h2>下一位同行者，<br>也许就是你。</h2><p>期待在鱼香 ROS 与你见面。</p></section>
  </div>
</template>

<script>
export default {
  name: 'JoinUs',
  data () {
    return {
      rosResponsibilities: [
        '负责机器人驱动层、控制层及 ROS2 节点的开发与优化',
        '开发基于 YOLO 的目标检测与视觉感知功能，完成数据、训练及效果优化',
        '完成视觉算法与 ROS/ROS2 系统集成，维护 Launch 文件及系统配置',
        '参与机器人系统联调、硬件通信对接与整机测试'
      ],
      rosRequirements: [
        '熟练掌握 ROS/ROS2，具备 C++、Python 项目开发经验',
        '熟悉 YOLO 目标检测流程及视觉算法在 ROS/ROS2 中的部署与可视化',
        '熟悉电机、传感器驱动及 CAN、RS485、UART、Ethernet 等通信接口',
        '具备机器人多模块集成、联调及问题定位能力',
        '有 SLAM、导航、规控、感知算法，开源项目、论文或竞赛获奖经历者优先',
        '有 STM32、ESP32、OpenCV、PyTorch、TensorRT、ONNX 或实际机器人项目经验者优先'
      ],
      structureResponsibilities: ['负责结构件设计（3D 打印 / 钣金 / 铝合金等）', '输出工程图纸及 BOM，跟进加工与装配', '参与样机调试与结构迭代'],
      structureRequirements: ['机械设计相关专业，本科及以上', '熟练使用 SolidWorks / Creo 等三维设计软件', '熟悉无刷电机及常见传动结构选型逻辑', '有完整样机开发或产品落地经验', '具备较强工程实现能力']
    }
  }
}
</script>

<style scoped>
.join-page {
  width: 88%;
  max-width: 1180px;
  margin: 0 auto;
  padding-bottom: 42px;
  color: #17212b;
  letter-spacing: 0;
}
.join-hero { min-height: 350px; background: #162b3a; color: #fff; padding: 48px 64px; display: flex; justify-content: space-between; align-items: center; overflow: hidden; position: relative; }
.hero-copy { max-width: 650px; position: relative; z-index: 1; }
.eyebrow { font: 600 11px/1.2 'Courier New', monospace; color: #e86d4f; margin-bottom: 18px; }
h1 { font-size: 48px; line-height: 1.15; margin: 0 0 18px; }
h1 em { color: #f4a261; font-style: normal; }
.hero-desc { max-width: 520px; color: #b9c7d0; line-height: 1.7; margin-bottom: 28px; }
.primary-button { display: inline-flex; align-items: center; gap: 18px; background: #e86d4f; color: white; padding: 13px 18px; font-weight: 600; }
.primary-button span { font-size: 18px; }
.hero-mark { width: 250px; height: 250px; border: 1px solid rgba(255,255,255,.22); border-radius: 50%; position: relative; transform: rotate(-15deg); }
.hero-mark span { position: absolute; color: #f4a261; font-size: 48px; }
.hero-mark span:nth-child(1) { top: 18px; left: 104px; }
.hero-mark span:nth-child(2) { right: 30px; bottom: 44px; }
.hero-mark span:nth-child(3) { left: 32px; bottom: 32px; color: #e86d4f; }
.content-section {
  padding: 40px 0 12px;
  text-align: left;
}
.section-heading .eyebrow { margin-bottom: 10px; }
.section-heading h2 { font-size: 26px; line-height: 1.4; margin-bottom: 10px; }
.section-heading > p:last-child { font-size: 14px; line-height: 1.8; color: #5f6b73; }
.job-detail { margin-top: 24px; padding: 28px 0; border-top: 1px solid #cbd2d6; border-bottom: 1px solid #cbd2d6; }
.job-detail-top { display: flex; justify-content: space-between; align-items: center; gap: 24px; }
.job-heading { min-width: 0; }
.job-heading h3 { margin: 0 0 12px; font-size: 28px; line-height: 1.4; }
.job-meta { display: flex; flex-wrap: wrap; gap: 12px; color: #5f6b73; font-size: 14px; line-height: 1.5; }
.job-meta span + span { border-left: 1px solid #b6bec4; padding-left: 12px; }
.job-contact { display: flex; flex-direction: column; align-items: flex-end; gap: 10px; flex-shrink: 0; }
.contact-email { color: #b6442b; font-weight: 600; font-size: 16px; line-height: 1.5; }
.contact-email:hover { text-decoration: underline; }
.job-link { display: inline-flex; align-items: center; gap: 6px; padding: 9px 14px; border-radius: 4px; background: #17212b; color: #fff; font-size: 14px; font-weight: 600; white-space: nowrap; }
.job-link:hover { background: #35434e; }
.job-link:focus-visible, .contact-email:focus-visible { outline: 2px solid #b6442b; outline-offset: 4px; }
.job-keywords { margin-top: 28px; }
.keyword-row { display: grid; grid-template-columns: 88px minmax(0, 1fr); gap: 16px; padding: 16px 0; border-top: 1px solid #d2d8dc; font-size: 14px; line-height: 1.9; }
.keyword-row:last-child { padding-bottom: 0; }
.keyword-row dt { color: #17212b; font-weight: 600; }
.keyword-row dd { margin: 0; color: #52606b; overflow-wrap: anywhere; }
.experience-list { display: flex; flex-wrap: wrap; column-gap: 28px; row-gap: 6px; list-style-position: outside; padding-left: 18px; }
.experience-list li::marker { color: #b6442b; }
.apply-section { text-align: center; padding: 48px 20px 28px; }
.apply-section h2 { font-size: 32px; line-height: 1.25; margin: 0 0 18px; }
.apply-section p { color: #6a737c; margin: 0 0 8px; }
@media (max-width: 768px) {
  .join-page { width: 92%; }
  .join-hero { min-height: auto; padding: 40px 28px; }
  h1 { font-size: 34px; }
  .hero-mark { position: absolute; right: -100px; bottom: -70px; opacity: .55; }
  .content-section { padding-top: 30px; }
  .job-detail-top { align-items: flex-start; flex-direction: column; gap: 18px; }
  .job-heading h3 { font-size: 24px; }
  .job-contact { align-items: flex-start; }
  .keyword-row { grid-template-columns: 1fr; gap: 6px; }
  .experience-list { display: block; }
  .experience-list li + li { margin-top: 6px; }
  .apply-section { padding-top: 36px; }
}
</style>
